@if (period.isLoading()) {
  <div class="flex justify-center w-full h-full items-center bg-white z-50">
    <app-loading [noWhitespace]="true"></app-loading>
  </div>
} @else if (period.error()) {
  <div class="flex justify-center w-full h-full items-center bg-opacity-10 bg-white z-50">
    <div class="text-red-500">{{ { key: 'errorLoading' } | i18n }}</div>
  </div>
} @else {
  <div class="h-full w-full relative" [class.opacity-0]="period.isLoading()">
    @if (period.value(); as p) {
      <div class="absolute flex flex-col gap-2 top-4 right-4 p-4 ml-4 rounded-md bg-opacity-75 bg-white z-50">
        <div class="font-bold">
          {{ p.designation | i18n }}
        </div>
        <div class="text-sm">
          {{ formatDate(p.from) }} -
          {{ formatDate(p.until) }}
        </div>

        <div class="flex flex-row gap-2 items-center">
          <div class="w-3 h-3 rounded-full bg-blue-600"></div>
          <div class="text-sm">{{ reservedCount() }} Verfügbar</div>
        </div>
        <div class="flex flex-row gap-2 items-center">
          <div class="w-3 h-3 rounded-full bg-red-500"></div>
          <div class="text-sm">{{ availableCount() }} Reserviert</div>
        </div>
      </div>
    }

    <app-map [options]="mapOptions"></app-map>
  </div>
}
